import { BlockedValueModalTranslations } from "./blocked-value-modal-pt-br";

export const BLOCKED_VALUE_MODAL_ES_MX: BlockedValueModalTranslations = {
	title: "Valor Bloqueado",
	description: "¿Qué son los valores bloqueados?",
	descriptionText: [
		"Los valores bloqueados son montos temporalmente no disponibles",
		"debido a políticas de seguridad o procesamiento de transacciones.",
	].join(" "),
	totalSummary: "Suma Total",
	liquidationDate: "FECHA DE LIQUIDACIÓN",
	competenceDate: "FECHA DE COMPETENCIA",
	type: "TIPO",
	category: "CATEGORÍA",
	observation: "OBSERVACIÓN",
	value: "VALOR",
	blockTypes: {
		"Bloqueio automático": "Bloqueo automático",
		"Bloqueio manual": "Bloqueo manual",
		"Cessão de recebíveis": "Cesión de cuentas por cobrar",
	},
	blockCategories: {
		"Transferência de titularidade": "Transferencia de titularidad",
		"Ônus - Cessão fiduciária": "Gravamen - Cesión fiduciaria",
		"Ônus - Outros": "Gravamen - Otros",
		"Bloqueio judicial": "Bloqueo judicial",
		"Promessa de Cessão": "Promesa de cesión",
		"Tipo desconhecido": "Tipo desconocido",
	},
	blockObservationPrefixes: {
		"CNPJ do solicitante:": "RFC del solicitante:",
	},
};
